import { useId, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

/* =====================================================================
   El campo de contraseña de TEGO, con su «ojo» · 19 de septiembre de 2026
   =====================================================================
   UNA sola pieza para TODAS las pantallas donde se escribe una
   contraseña (crear cuenta, entrar, cambiarla, restablecerla, fijar
   credenciales, CSD, PIN de caja). Antes cada pantalla tenía su propio
   input y solo el alta traía el ojo.

   Reglas, y por qué:
   · El botón es un botón de verdad: se alcanza con Tab y se activa con
     Enter/Espacio (`aria-pressed` dice el estado). El ojo del alta
     llevaba `tabIndex={-1}` y quien navega con teclado no lo alcanzaba.
   · NO revela al copiar: aunque la contraseña esté visible, copiar o
     cortar el campo no se lleva el texto al portapapeles. Ver es para
     comprobar que se tecleó bien, no para sacarla de aquí.
   · NO persiste entre pantallas: el estado vive en el componente y nace
     oculto en cada montaje. Cambiar de pantalla la vuelve a ocultar.
   · Sin autocorrección ni mayúsculas automáticas del teléfono.
   ===================================================================== */
// Peaje U-02: el gris es solo el color POR OMISIÓN. Si quien llama pasa
// `claseBoton` con su tinta, se usa SOLO la suya: con las dos clases a la vez
// ganaba la que Tailwind generase después, y en la puerta oscura el «Ver»
// quedaba en text-gray-600 sin remapear (2,28:1 medido el 6 oct 2026).
const COLOR_BOTON = 'text-gray-600 hover:text-gray-900';

export default function CampoContrasena({
  id, value, onChange, autoComplete = 'current-password', className = '',
  claseBoton = '', inputRef, visible: visibleControlado, onVisible, ...resto
}) {
  // Por omisión cada campo lleva su propio ojo. Dos campos que deben
  // abrirse a la vez (contraseña + confirmación) lo comparten pasando
  // `visible` y `onVisible` desde fuera.
  const [visibleLocal, setVisibleLocal] = useState(false);
  const controlado = typeof visibleControlado === 'boolean' && typeof onVisible === 'function';
  const visible = controlado ? visibleControlado : visibleLocal;
  const setVisible = (fn) => (controlado ? onVisible(fn(visible)) : setVisibleLocal(fn));
  const generado = useId();
  const idFinal = id || generado;
  const bloquear = (e) => { if (visible) e.preventDefault(); };
  return (
    <div className="relative">
      <input
        {...resto}
        ref={inputRef}
        id={idFinal}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        autoCapitalize="off" autoCorrect="off" spellCheck={false}
        onCopy={bloquear} onCut={bloquear}
        className={`${className} pr-20`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-pressed={visible}
        aria-controls={idFinal}
        aria-label={visible ? 'Ocultar la contraseña' : 'Ver la contraseña'}
        className={`absolute inset-y-0 right-0 px-3 inline-flex items-center gap-1 text-[0.8125rem] font-semibold focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded-r-lg ${claseBoton || COLOR_BOTON}`}
      >
        {visible
          ? <><EyeOff className="h-4 w-4" aria-hidden="true" /> Ocultar</>
          : <><Eye className="h-4 w-4" aria-hidden="true" /> Ver</>}
      </button>
    </div>
  );
}
